<template>
  <div
    class="account-pane account-pane-small account-overview lister-branding"
    :class="{ active: active }"
    data-account-pane="overview"
  >
    <div class="heading align-center font-std uc fg-secondary">
      Your Account
    </div>

    <vue-simplebar class="menu-content">
      <h3 class="wt-sb font-lg lh-tight mb-8">
        Hello,<br />
        <span class="fg-primary">
          {{ user.first_name }} {{ user.last_name }}
        </span>
      </h3>

      <div class="account-overview-menu">
        <ul>
          <li>
            <span class="link-like" @click="goToListings">Listings</span>
            <span class="tags"></span>
          </li>
          <li>
            <span class="link-like" @click="goToBookings">Bookings</span>
            <span class="tags"></span>
          </li>
          <li>
            <span class="link-like" @click="goToAccount">Account details</span>
            <span class="tags">
              <span class="alert-tag error mb-1" v-if="$store.getters['user/shouldCompleteProfile']">Complete your profile</span>
              <span class="alert-tag error" v-if="!$store.getters['user/stripeConnectIsOnboarded'] && !$store.getters['user/bankAccountOnboarded']">Incomplete Payment details</span>
            </span>
          </li>
          <li class="list-your-space">
            <list-your-space-button
              class="button primary block"
              classes="primary"
              label="List Your Space"
            ></list-your-space-button>
          </li>
          <li class="log-out">
            <loader-button
              @click.native="logout"
              label="Log Out"
              class="primary"
              :loading="loading"
              :block="true"
            ></loader-button>
          </li>
        </ul>
      </div>
    </vue-simplebar>
  </div>
</template>

<script>
import AccountPane from "../../AccountPane";

export default {
  extends: AccountPane,
  data() {
    return {
      id: "overview",
      loading: false,
      bank_account_details_completed: false,
    };
  },
  methods: {
    goToListings() {
      this.$store.commit('account/hide');
      this.$store.commit('findspace/navigateToSubpage', { page: 'listings', subpage: 'home' })
    },
    goToAccount() {
      this.$store.commit('account/hide');
      this.$store.commit('findspace/navigateToSubpage', { page: 'account', subpage: 'account' })
    },
    goToBookings() {
      this.$store.commit('account/hide');
      this.$store.commit('findspace/navigateToSubpage', { page: 'bookings', subpage: 'home' })
    },
    logout() {
      this.loading = true;
      this.$store
        .dispatch("user/logout")
        .then(() => {})
        .catch(() => {})
        .then(() => {
          this.$store.commit("account/hide", true);
          this.$toasted.show(`You have logged out successfully.`, {
            type: "success",
          });
          this.loading = false;
        });
    },
  },
  mounted() {
    this.$store.commit('findspace/setUserType', { userType: 'lister' })
  },
};
</script>
